import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, ArrowUpRight } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_seva-solutions-hub/artifacts/4q0pq3ne_34.jpeg';

const footerLinks = {
  Company: ['/about','About Us','/services','Services','/products','Products','/blog','Blog','/contact','Contact'],
  Products: ['/products','Industrial Gases','/products','Medical Gases','/products','Cryogenic Liquids','/products','Gas Mixtures','/products','Gas Accessories'],
  Services: ['/services','Hydrostatic Testing','/services','Cryogenic Maintenance','/services','Air Separation Plants','/services','Gas Analysis','/services','Offshore Purging'],
};

const sections = Object.entries(footerLinks).map(([title, items]) => ({
  title,
  links: Array.from({ length: items.length / 2 }, (_, i) => ({ path: items[i * 2], label: items[i * 2 + 1] })),
}));

export default function Footer() {
  return (
    <footer className="bg-[#181818] text-white">
      {/* Top bar */}
      <div className="border-b border-white/5 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs uppercase tracking-[0.2em] font-bold">India's All-in-One Gas Solutions Provider. From Planning to Execution.</p>
          <Link to="/contact" className="flex items-center gap-2 bg-[#CC2222] text-white px-6 py-2.5 text-xs font-bold uppercase tracking-wider hover:bg-[#A81C1C] transition-colors">
            Get a Quote <ArrowUpRight size={12} />
          </Link>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="inline-block bg-white px-3 py-2 mb-6">
              <img src={LOGO_URL} alt="Seva Gases" className="h-[60px] w-auto" style={{ mixBlendMode: 'multiply' }} />
            </div>
            <p className="text-white/35 text-sm leading-relaxed mb-7 max-w-xs">
              One of India's leading industrial gas companies manufacturing, trading, and supplying gases for medical, industrial, and commercial applications worldwide.
            </p>
            <div className="space-y-2.5">
              <div className="flex items-start gap-3">
                <MapPin size={13} className="text-[#CC2222] mt-0.5 flex-shrink-0" />
                <p className="text-white/30 text-xs leading-relaxed">SF NO: 328/1D1, Alampalayam Pirivu,<br />Coimbatore – 641107, Tamilnadu, India</p>
              </div>
              <a href="tel:+919894020509" className="flex items-center gap-3 text-white/30 text-xs hover:text-white/60 transition-colors">
                <Phone size={13} className="text-[#CC2222] flex-shrink-0" /> +91 9894020509
              </a>
              <a href="mailto:info@sevagases.com" className="flex items-center gap-3 text-white/30 text-xs hover:text-white/60 transition-colors">
                <Mail size={13} className="text-[#CC2222] flex-shrink-0" /> info@sevagases.com
              </a>
            </div>
          </div>

          {sections.map(s => (
            <div key={s.title}>
              <h4 className="text-white/80 font-bold text-[11px] uppercase tracking-[0.2em] mb-5 font-heading">{s.title}</h4>
              <ul className="space-y-2.5">
                {s.links.map(l => (
                  <li key={l.label}>
                    <Link to={l.path} className="text-white/30 text-sm hover:text-white/70 transition-colors duration-200 flex items-center gap-2 group">
                      <span className="w-3 h-px bg-white/10 group-hover:bg-[#CC2222] group-hover:w-4 transition-all duration-200 flex-shrink-0" />
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-white/5 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/20 text-xs">© {new Date().getFullYear()} Seva Gases. All rights reserved. Energy for Engineering.</p>
          <div className="flex items-center gap-5">
            <span className="text-white/15 text-xs">Coimbatore | Trichy</span>
            <Link to="/admin" className="text-white/15 text-xs hover:text-white/30 transition-colors">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
